import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, watch } from "vue";

import CharacterSheet from "@/pages/CharacterSheet/CharacterSheet.vue";

import { validateCharacter } from "@/shared/helpers/validators";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";

// TODO: Apply Feature-Sliced Design to the project


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useCharactersStore();
const i18 = useI18n();

const { characters } = storeToRefs(store);

watch(i18.locale, (language) => {
	window.localStorage.language = language;
});

watch(
	characters,
	(characters) => {
		window.localStorage.characters = JSON.stringify(characters);
	},
	{
		deep: true,
	}
);
onMounted(() => {
	i18.locale.value = window.localStorage.language || "en";

	if (window.localStorage.characters) {
		const parsedCharacters = JSON.parse(window.localStorage.characters);
		if (
			Array.isArray(parsedCharacters) &&
			parsedCharacters.every(validateCharacter)
		) {
			store.loadCharacters(parsedCharacters);
		}
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CharacterSheet))
}
}

})